import './ContactContainer.css'
import { Contact } from '../../components/Contact/Contact'

export const ContactContainer = () => {
    return <Contact />
}